import React from 'react';
import PropTypes from 'prop-types';

const BackButton = props => {
  const { text, triggerBack } = props;
  return (
    <div
      className="apps-back"
      role="button"
      onKeyDown={e => e.keyCode === 13 && triggerBack()}
      onClick={triggerBack}
      tabIndex={0}
    >
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        enableBackground="new 0 0 24 24"
      >
        <path
          fill="#FFFFFF"
          d="M19.791 12.5H3.5a.5.5 0 1 1 0-1h16.295l-6.149-6.146a.5.5 0 1 1 .708-.708l7 6.998a.5.5 0 0 1 0 .708l-7 7.001a.5.5 0 1 1-.707-.706l6.144-6.147z"
        />
      </svg>
      {text}
    </div>
  );
};

BackButton.propTypes = {
  text: PropTypes.string,
  triggerBack: PropTypes.func
};

export default BackButton;
